var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 14.666H4.66634C1.99967 14.666 1.33301 13.9993 1.33301 11.3327V9.99935C1.33301 7.33268 1.99967 6.66602 4.66634 6.66602H11.333C13.9997 6.66602 14.6663 7.33268 14.6663 9.99935V11.3327C14.6663 13.9993 13.9997 14.666 11.333 14.666Z",
    stroke: "#586370",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66732V5.33398C4 3.12732 4.66667 1.33398 8 1.33398C11 1.33398 12 2.66732 12 4.66732",
    stroke: "#586370",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 12.3333C8.92015 12.3333 9.66634 11.5871 9.66634 10.6667C9.66634 9.74619 8.92015 9 7.99967 9C7.0792 9 6.33301 9.74619 6.33301 10.6667C6.33301 11.5871 7.0792 12.3333 7.99967 12.3333Z",
    stroke: "#586370",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockIconOutline);
export default __webpack_public_path__ + "static/media/unlockIconOutline.71306af57c4e3f1d941b4c45afbe999b.svg";
export { ForwardRef as ReactComponent };